module.exports = __webpack_public_path__ + "img/money.6fe27e7a.svg";